var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/column.tsx";
const _excluded = ["heading", "icon", "children", "active"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { v4 } from 'uuid';
import Pullable from 'soapbox/components/pullable';
import { Column } from 'soapbox/components/ui';
import ColumnHeader from './column_header';
const UIColumn = _ref => {
  let {
      heading,
      icon,
      children,
      active
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const columnHeaderId = typeof heading === 'string' ? heading.replace(/ /g, '-') : v4();
  return /*#__PURE__*/React.createElement(Column, _extends({
    "aria-labelledby": columnHeaderId
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 5
    }
  }), heading && /*#__PURE__*/React.createElement(ColumnHeader, {
    icon: icon,
    active: active,
    type: heading,
    columnHeaderId: columnHeaderId,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(Pullable, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  }, children));
};
export default UIColumn;